import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Shield } from "lucide-react";

export default function AdminLogin() {
  const { t, login, token, role } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [sp] = useSearchParams();
  const nextPath = sp.get("next") || "/admin/panel";

  // Session is persistent (JWT in localStorage). If we already have an admin
  // session, skip the login screen — the browser back button must not land
  // on an empty form and mimic a logout.
  useEffect(() => {
    if (token && role === "admin") nav(nextPath, { replace: true });
  }, [token, role, nav, nextPath]);

  const submit = async () => {
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      login(r.data.token, "admin", { email: r.data.email });
      nav(nextPath);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-6 sm:p-8">
          <div className="w-11 h-11 rounded-xl bg-slate-900 flex items-center justify-center mb-4">
            <Shield className="text-white" size={22}/>
          </div>
          <h1 className="text-2xl font-bold text-slate-900">{t.admin.loginTitle}</h1>
          <div className="space-y-3 mt-5">
            <div><Label>{t.admin.email}</Label>
              <Input data-testid="admin-email-input" type="email" value={email} onChange={e => setEmail(e.target.value)}/></div>
            <div><Label>{t.admin.password}</Label>
              <Input data-testid="admin-password-input" type="password" value={password} onChange={e => setPassword(e.target.value)}/></div>
          </div>
          <Button data-testid="admin-login-btn" onClick={submit} disabled={loading}
                  className="w-full mt-5 h-11 bg-slate-900 hover:bg-slate-800 font-semibold">
            {t.admin.login}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
